var logger = require('./logger');
function encode(obj) {
    var str = '';
    for (var i in obj) {
        if (obj.hasOwnProperty(i)) {
            if (str.length) str += '&';
            str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
        }
    }
    return str;
}

function get(url, data) {
    var searchParams = encode(data);
    url = url + (searchParams && (url.indexOf('?') > -1 ? '&' : '?')) + searchParams;
    return fetch(url, {
        credentials: 'include',
    }).then(function (response) {
        return response.json();
    }).catch(function (e) {
        logger.error('[umu-upload] get error:', url, data, e);
        // throw e;
    });
}

function post(url, data, options) {
    var body = encode(data);
    options = Object.assign({}, options, {
        body: body,
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    });
    return fetch(url, options)
        .then(function (response) {
            if (!response.ok) {
                // 记录非200响应
                response.text().then(function (text) {
                    logger.error('[umu-upload] post response not ok', {
                        url: url,
                        data: data,
                        options: options,
                        status: response.status,
                        statusText: response.statusText,
                        responseText: text,
                    });
                });
            }
            return response.json();
        })
        .catch(function (e) {
            logger.error('[umu-upload] post error:', {
                url: url,
                data: data,
                options: options,
                error: e && (e.stack || e.toString()),
            });
            // throw e;
        });
}

function postJson(url, data, options) {
    return fetch(
        url,
        Object.assign({}, options, {
            body: JSON.stringify(data),
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
        })
    )
        .then(function (response) {
            if (!response.ok) {
                response.text().then(function (text) {
                    logger.error('[umu-upload] postJson response not ok', {
                        url: url,
                        data: data,
                        options: options,
                        status: response.status,
                        statusText: response.statusText,
                        responseText: text,
                    });
                });
            }
            return response.json();
        })
        .catch(function (e) {
            logger.error('[umu-upload] postJson error:', {
                url: url,
                data: data,
                options: options,
                error: e && (e.stack || e.toString()),
            });
            throw e;
        });
}

module.exports = {
    get: get,
    post: post,
    postJson: postJson,
};
